import React, { PureComponent } from 'react';
import { DateRangePicker } from 'react-date-range';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import { altDateFormat } from 'utils/date';

import { LocaleContext } from 'context/LocaleContext';

import Popout from './popout';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

class CustomDatePicker extends PureComponent {
    static contextType = LocaleContext;

    static defaultProps = {
        confirmClassName: 'btn-success',
        cancelClassName: 'btn-secondary',
        closeFromDoc: true,
        closeOnClickOut: true
    };

    state = {
        selectionRanges: [{
            startDate: this.props.start ? new Date(this.props.start) : new Date(),
            endDate: this.props.end ? new Date(this.props.end) : new Date(),
            color: '#00a99b',
            key: 'selection'
        }]
    };

    handleChange = ({ selection }) => {
        const { startDate, endDate } = selection;

        this.setState({
            selectionRanges: [{
                ...this.state.selectionRanges[0],
                startDate,
                endDate: moment(endDate).endOf('day').toDate()
            }]
        });
    }

    handleConfirmClick = () => {
        const selectionRange = this.state.selectionRanges[0];

        this.props.onChange({
            start: selectionRange.startDate,
            end: selectionRange.endDate
        });

        this.hide();
    }

    handleCancelClick = () => {
        this.hide();
    }

    handleRemoveClick = () => {
        this.hide();
        this.props.onRemove();
    }

    hide() {
        this.popoutCtrl && this.popoutCtrl.hide();
    }

    componentDidMount() {
        const ctrl = {
            show: event => {
                return this.popoutCtrl && this.popoutCtrl.show(event);
            },
            hide: () => {
                this.popoutCtrl && this.popoutCtrl.hide();
            },
            // setOverlayParentElement: element => {
            //     this.setOverlayParentElement(element);
            //     this.positionOverlayElement();
            // },
            // updatePosition: () => {
            //     this.positionOverlayElement();
            // },
            // isVisible: () => {
            //     return this.state.visible;
            // }
        };

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = ctrl;
            } else {
                this.props.provideController && this.props.provideController(ctrl);
            }
        }
    }

    componentWillUnmount() {
        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = null;
            } else {
                this.props.provideController && this.props.provideController(null);
            }
        }
    }

    componentDidUpdate(prevProps) {
        const selectionRange = this.state.selectionRanges[0];
        if (
            (prevProps.start !== this.props.start && new Date(this.props.start).getTime() !== selectionRange.startDate.getTime()) ||
            (prevProps.end !== this.props.end && new Date(this.props.end).getTime() !== selectionRange.endDate.getTime())
        ) {
            this.setState({
                selectionRanges: [{
                    ...selectionRange,
                    startDate: new Date(this.props.start),
                    endDate: new Date(this.props.end)
                }]
            });
        }
    }

    setCtrl = ctrl => this.popoutCtrl = ctrl;

    render() {
        const { t } = this.props;

        return (
            <Popout
                className="popout-datepicker"
                xAlign={this.props.xAlign}
                onShow={this.props.onShow}
                onHide={this.props.onHide}
                provideController={this.setCtrl}
            >
                {
                    this.props.title ?? true ? (
                        <div className="popout-head">
                            { this.props.title ?? t('date:Select range') }
                        </div>
                    ) : null
                }

                <div className="popout-body">
                    <div className="datepickers-holder">
                        <DateRangePicker
                            moveRangeOnFirstSelection={true}
                            dateDisplayFormat={altDateFormat(this.context.dateTimeFormats.fullDate)}
                            ranges={this.state.selectionRanges}
                            color="#00a99b"
                            weekStartsOn={this.context.weekStart}
                            onChange={this.handleChange}
                        />
                    </div>
                </div>

                <div className="popout-foot">
                    {
                        this.props.onRemove ? <button className="btn btn-small btn-link btn-text-warning" onClick={this.handleRemoveClick}>{this.props.removeText ?? t('Clear')}</button> : null
                    }

                    <div className="btn-group btn-group-auto">
                        <button className={'btn btn-small ' + this.props.cancelClassName} onClick={this.handleCancelClick}>{this.props.cancelText ?? t('Cancel')}</button>

                        <button className={'btn btn-small ' + this.props.confirmClassName} onClick={this.handleConfirmClick}>{this.props.confirmText ?? t('Select')}</button>
                    </div>
                </div>
            </Popout>
        )
    }
}

export default withTranslation(['common', 'date'])(CustomDatePicker);
